/**
 * Tv Module name
 */
export enum TvModuleName {
  Svg = 'SVG',
  Information = 'Information',
  Stat = 'Stat',
  ViewBill = 'ViewBill',
  RemoteControl = 'RemoteControl',
  VirtualScroll = 'VirtualScroll',
  TvMosaic = 'tv_mosaic',
  Services = 'Services',
  Shop = 'Shop',
  Epg = 'Epg',
  CustomNotification = 'CustomNotification',
  Apps = 'Apps',
  Menu = 'Menu',
  Messages = 'Messages',
  ScrollContainer = 'ScrollContainer',
  PictureMode = 'PictureMode',
  VerticalGallery = 'VerticalGallery',
  YandexStation = 'YandexStation',

  AirPlayBuiltIn = 'AirPlayBuiltIn',
  AirStream = 'AirStream',
  Chromecast = 'Chromecast',
  CSCast = 'CSCast',
  Disney = 'Disney',
  DoorEye = 'DoorEye',
  GoogleCastBuiltIn = 'GoogleCastBuiltIn',
  Housekeeping = 'Housekeeping',
  LgAirServer = 'LGAirServer',
  Logout = 'Logout',
  Media2 = 'Media2',
  Mod = 'MOD',
  OldMod = 'oldMOD',
  PeninsulaRs232 = 'Peninsula_rs232',
  PeninsulaVod = 'Peninsula_vod',
  Radio = 'RADIO',
  RemoteState = 'RemoteState',
  Sanatorium = 'Sanatorium',
  ScandicWelcome = 'ScandicWelcome',
  Welcome = 'Welcome',
  Screensaver = 'Screensaver',
  Tests = 'Tests',
  UpdateInfoGorki = 'UpdateInfoGorki',
  VerticalChannel = 'VerticalChannel',
  Vod = 'VOD',
  VodHtml5 = 'VODhtml5',
  WakeUpCall = 'Wakeupcall',
  WakeUpCall2 = 'Wakeupcall2',

  // Widgets:
  Flights = 'Flights',
  Weather = 'Weather',
  GorkiGorod = 'GorkiGorod',
}
